/**
 * Trójwymiarowe współrzędne (X - szerokość, Y - wysokość, Z - głębia)
 */
export class MultiFanCoordinates {
    constructor(
        readonly xMeters: number,
        readonly yMeters: number,
        readonly zMeters: number
    ) {}

    static fromObject(obj: { xMeters: number; yMeters: number; zMeters: number }): MultiFanCoordinates {
        return new MultiFanCoordinates(obj.xMeters, obj.yMeters, obj.zMeters);
    }
}

/**
 * Sekwencja numerów wentylatorów - globalny licznik
 */
export class FanNumberSequence {
    private currentNumber = 0;

    getNextNumber(): number {
        return ++this.currentNumber;
    }
}

/**
 * Parametry wejściowe do utworzenia sytuacji
 */
export type MultiFanSituationInputParameters = {
    fanPwlDba: number;
    additionalUserGivenFanPwlDba: number;
    fanColumnCountInCooler: number;
    fanRowCountInCooler: number;
    coolerWidthMeters: number;
    coolerHeightMeters: number;
    coolerZCoordinate: number;
    fanCaseDiameterMeters?: number;
    totalCoolerColumnCount: number;
    totalCoolerRowCount: number;
    xDistanceBetweenCoolers: number;
    yDistanceBetweenCoolers: number;
    observerPosition: { xMeters: number; yMeters: number; zMeters: number };
}
